import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg'

export default CheckIcon
